import drFaidaro from "../assets/images/Dr-Faidaro.png";
import profDaudu from "../assets/images/Prof-Daudu.png";
import profAmapu from "../assets/images/Prof-Amapu.png";
import profAisha from "../assets/images/Prof-Aisha.png";
import drGoni from "../assets/images/Dr-Goni.png";
import abdulshakur from "../assets/images/abdulshakur.png";
import zakari from "../assets/images/zakari.png";
import ABU_LOGO from "../assets/images/ABU-Logo.png";
import AFAAS_LOGO from "../assets/images/AFAAS-Logo.png";
import FARA_LOGO from "../assets/images/FARA-Logo.png";
import Nippon_LOGO from "../assets/images/Nippon-Foundation-Logo.jpg";
import SAA_LOGO from "../assets/images/SAA-Logo.png";

export const homeStats = [
  { labelKey: "home.stats.newSoilSamples", value: "166" },
  { labelKey: "home.stats.legacyRecords", value: "5,000+" },
  { labelKey: "home.stats.pilotStates", value: "Kaduna & Kano" },
];

export const advisoryTopics = [
  "home.advisoryTopics.n_p",
  "home.advisoryTopics.k",
  "home.advisoryTopics.oc_ph",
];

// Replace these placeholders with the definitive list when you’re ready.
export const coreTeam = [
    {
    name: "Prof. C.K. Daudu",
    roleKey: "home.roles.pincipalCoordinator",
    image: profDaudu,
    linkedIn: "https://www.linkedin.com/in/christogonus-daudu-2573ab20/",
  },
  {
    name: "Dr. Anjaoluwa Faidaro",
    roleKey: "home.roles.saaCoordinator",
    image: drFaidaro,
    linkedIn: "https://www.linkedin.com/in/fadairoanjolaoluwa/",
  },
  {
    name: "Prof. I.Y. Amapu",
    roleKey: "home.roles.deputyCoordinator",
    image: profAmapu,
    linkedIn: "https://www.linkedin.com/in/ishaku-amapu-b0809714/",
  },
  {
    name: "Prof. Aisha Abdulkadir",
    roleKey: "home.roles.technicalOfficer",
    image: profAisha,
    linkedIn: "https://www.linkedin.com/in/aisha-abdulkadir-a950462a/",
  },
  {
    name: "Dr. Adam Ali Goni",
    roleKey: "home.roles.m&eLead",
    image: drGoni,
    linkedIn: "https://www.linkedin.com/in/ali-goni-adam-phd-b6a251105",
  },
  {
    name: "Mahmud Abdulshakur",
    roleKey: "home.roles.m&eAsst",
    image: abdulshakur,
    linkedIn: "https://www.linkedin.com/in/abdulshakur-mahmud-11681919a",
  },
  {
    name: "Oyabure Zakari",
    roleKey: "home.roles.ictLead",
    image: zakari,
    linkedIn: "https://www.linkedin.com/in/zakari-oyabure-84933133b/",
  },
];

export const partners = [
  { name: "Nippon Foundation", logo: Nippon_LOGO },
  { name: "Sasakawa Africa Association (SAA)", logo: SAA_LOGO },
  { name: "AFAAS", logo: AFAAS_LOGO },
  { name: "ABU Zaria (NAERLS)", logo: ABU_LOGO },
  { name: "FARA", logo: FARA_LOGO },
];
